<script setup lang="ts">
import { ref } from 'vue';
import AuthFlow from '@/components/shared/AuthFlow.vue';
import { IProfile, IShift } from '@/interfaces';
import ReplaceShiftEmployeeOverlay from '@/views/workSchedule/ReplaceShiftEmployeeOverlay.vue';
import ReplaceShiftConfirmationOverlay from '@/views/workSchedule/ReplaceShiftConfirmationOverlay.vue';

interface Props {
  titleSuccess: string;
  title: string;
  shift: IShift;
}

withDefaults(defineProps<Props>(), {});

const showAuthFlow = ref<boolean>(false);
const showConfirmReplaceOverlay = ref<boolean>(false);
const selectedEmployee = ref<IProfile>();
const emit = defineEmits(['close', 'success']);

const closeFlow = () => {
  showConfirmReplaceOverlay.value = false;
  showAuthFlow.value = false;
  emit('close');
};

const employeeSelected = (employee: IProfile) => {
  showConfirmReplaceOverlay.value = true;
  selectedEmployee.value = employee;
};

const onSuccess = async () => {
  emit('success', selectedEmployee.value);
};
</script>

<template>
  <ReplaceShiftEmployeeOverlay
    @close="closeFlow()"
    @success="employeeSelected"
  />

  <ReplaceShiftConfirmationOverlay
    v-if="showConfirmReplaceOverlay && selectedEmployee"
    :newProfile="selectedEmployee"
    :oldProfile="shift.employee"
    @close="showConfirmReplaceOverlay = false"
    @success="showAuthFlow = true"
  />

  <AuthFlow
    v-if="showAuthFlow"
    :title="title"
    :title-success="titleSuccess"
    :employee-only="true"
    @close="closeFlow"
    @success="onSuccess"
  />
</template>
